import React, { Component } from "react";
import PropTypes from "prop-types";
import { withCookies } from "react-cookie";
import { Row, Col, Navbar, Glyphicon } from "react-bootstrap";

import Phi from "../../../Phi/Phi";
import { hsg_white_logo } from "../../../Assets/logo/index";

import "./HSGHeader.css";
import "../../../Themes/Generic.css";
import HeaderButton from "../../../Components/HeaderButton";
import HeaderUser from "../../../Components/HeaderUser";
import HeaderDropdown from "../../../Components/HeaderDropdown";
import history from "../../../history";

const NAVBAR_MID_POINT = 1199;
const NAVBAR_FLIP_POINT = 767;

class HSGHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      height: 0,
    };
  }

  logout() {
    const cookies = this.props.cookies;
    cookies.remove("token", { path: "/" });
    cookies.remove("roles", { path: "/" });

    this.props.logoutUser();
  }

  changeRouteToDashboard() {
    history.push("/dashboard");
  }

  getOrganizationName = () => {
    const { organization, currentProgram } = this.props;
    let organizationName = sessionStorage.getItem("organizationName"); // Retrieve organization name from sessionStorage
    if (!organizationName) {
      // If organization name is not found in sessionStorage, use fallback logic to get the name
      organizationName =
        organization?.inOrganizationName ||
        currentProgram?.organization_name ||
        "";
      sessionStorage.setItem("organizationName", organizationName); // Store organization name in sessionStorage
    }
    return organizationName;
  };

  // Lifecycle Methods ==============================================================

  render() {
    const userProfile = Phi.User.profile();
    const userCustom = Phi.User.userCustomJson();
    const jsonValue = userCustom.json_value;
    return (
      <div ref="header" className="hsg-mh-root">
        <div
          className="show-grid fixed-top"
          style={{ background: "#1E87F0", height: "77px", flex: 1 }}
        >
          {/* Navbar Logo and Page Description */}
          <Col xs={6} sm={2} md={3} lg={5}>
            <img
              className="hsg-mh-logo"
              alt="Health Set Go"
              src={hsg_white_logo}
              style={{
                cursor: "pointer",
                width: "auto",
                height: "35px",

                objectFit: "contain",
              }}
              onClick={this.changeRouteToDashboard}
            />

            {/* {(this.state.width > NAVBAR_MID_POINT) && <span className="hsg-mh-desc">{this.props.heading}</span>} */}

            {/* <h2 className="hsg-mh-desc" style={{color:"white"}}>{`Welcome,${this.getOrganizationName(this.props.organization, this.props.currentProgram)}!`}</h2> */}

            {/* <h2 className="hsg-mh-desc " style={{ color: "white" }}>
 <p className='welcomeseprate'>Welcome,</p> 
</h2>
<div className='nextline ' style={{ whiteSpace: 'pre-line', color: 'white',  }}>
  {this.getOrganizationName(this.props.organization, this.props.currentProgram) }
</div>  */}

            <div className="v-linewelcome"></div>
            <div className="fixheadwelome">
              {this.props.organization &&
                this.getOrganizationName(
                  this.props.organization,
                  this.props.currentProgram,
                ) && (
                  <h2 className="hsg-mh-desc " style={{ color: "white" }}>
                    <p className="welcomeseprate">Welcome,</p>
                  </h2>
                )}

              <div className="nextline ">
                {this.props.organization &&
                  this.getOrganizationName(
                    this.props.organization,
                    this.props.currentProgram,
                  )}
              </div>
            </div>
          </Col>

          {/* Navbar Navigation Options */}
          {this.state.width > NAVBAR_FLIP_POINT && (
            <Col
              sm={7}
              lg={5}
              style={{ height: this.state.height }}
              ref="hsg-school-header-btn"
            >
              {(!!!jsonValue.actionMap ||
                (jsonValue.actionMap &&
                  jsonValue.actionMap.includes("dashboard"))) && (
                <HeaderButton
                  text="DASHBOARD"
                  glyph="fas fa-eye"
                  onClick={() => this.changeRoute("/dashboard")}
                  selected={this.props.location.pathname === "/dashboard"}
                />
              )}
              {(!!!jsonValue.actionMap ||
                (jsonValue.actionMap &&
                  jsonValue.actionMap.includes("studentList"))) && (
                <HeaderButton
                  // text="STUDENT LIST"
                  text="CARE ASSESSMENT"
                  glyph="fas fa-user"
                  // onClick={() => this.changeRoute("/student")}
                  onClick={() => this.changeRoute("/care-assessment")}
                  // selected={this.props.location.pathname === "/student"}
                  selected={this.props.location.pathname === "/care-assessment"}
                />
              )}
              {jsonValue.actionMap &&
                jsonValue.actionMap.includes("infirmary") && (
                  <HeaderButton
                    text="INFIRMARY"
                    glyph="fa fa-stethoscope"
                    onClick={() => this.changeRoute("/infirmary")}
                    selected={this.props.location.pathname === "/infirmary"}
                  />
                )}
              {jsonValue.actionMap &&
                jsonValue.actionMap.includes("smartClinic") && (
                  <HeaderButton
                    text="SMART CLINIC"
                    glyph="fa fa-stethoscope"
                    onClick={() => this.changeRoute("/smart-clinic")}
                    selected={this.props.location.pathname === "/smart-clinic"}
                  />
                )}
              {jsonValue.actionMap &&
                jsonValue.actionMap.includes("studentProfile") && (
                  <HeaderButton
                    text="STUDENT PROFILE"
                    glyph="fa fa-stethoscope"
                    onClick={() => this.changeRoute("/student-profile")}
                    selected={
                      this.props.location.pathname === "/student-profile"
                    }
                  />
                )}
              {(!!!jsonValue.actionMap ||
                (jsonValue.actionMap &&
                  jsonValue.actionMap.includes("upload"))) && (
                <HeaderButton
                  text="UPLOAD"
                  glyph="fas fa-cloud-upload-alt"
                  onClick={() => this.changeRoute("/upload")}
                  selected={this.props.location.pathname === "/upload"}
                />
              )}
            </Col>
          )}

          {/* Navbar User Image, Name and Account Options */}
          {this.state.width > NAVBAR_FLIP_POINT && (
            <Col sm={3} md={2} style={{ height: this.state.height }}>
              <div className="hsg-mh-user-wrapper">
                <HeaderUser name={"PROFILE"} image="#">
                  <HeaderDropdown
                    manageProfile
                    email={userProfile.username}
                    onClickManageProfile={() =>
                      this.changeRoute("/manage-profile")
                    }
                    onClickChangePassword={() => this.props.changePassword()}
                    onClickLogout={() => this.logout()}
                    onClickSupport={() => this.changeRoute("/support")}
                    roleType={this.props.roleType}
                  />
                </HeaderUser>
              </div>
            </Col>
          )}

          {/* Navbar Options Menu Button (small screens) */}
          {this.state.width <= NAVBAR_FLIP_POINT && (
            <Col xs={6}>
              <div
                className="hsg-mh-menu-icon right"
                onClick={() => {
                  this.props.onClickNavDrawer();
                }}
              >
                <Glyphicon glyph="menu-hamburger" />
              </div>
            </Col>
          )}
        </div>
      </div>
    );
  }

  changeRoute(path) {
    history.push(path);
  }

  componentDidMount() {
    this.setState({
      width: window.innerWidth,
      height: this.refs.header.offsetHeight,
    });

    if (Boolean(this.props.setHeaderElement)) {
      this.props.setHeaderElement(this.refs.header);
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.dim.width !== this.props.dim.width) {
      this.setState({
        width: window.innerWidth,
        height: this.refs.header.offsetHeight,
      });
    }
  }

  componentWillUnmount() {}

  // Event Listeners ==============================================

  // Other Methods ================================================

  getHeaderName() {
    /*let profile = Phi.User.profile()
        if (profile) {
            console.log("profile")
            return (
                `${profile.firstname || ''} ${profile.lastname || ''}`
            )
        }*/

    return "John Doe";
  }
}

export default withCookies(HSGHeader);

HSGHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  setHeaderElement: PropTypes.func,
};

HSGHeader.defaultProps = {
  heading: "HEALTH SET GO",
};
